module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/CMD-d9dc3ada714f5d15e083c5c1d00287318b3dd2ea10d0de1eacf5f67f4031765a.svg";